// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J1PHBbR3GyfoEvqufIPe {
  /* margin-top: 2rem; */
}

.E76NuDfGxJ8wj35W3a03 {
  text-decoration: none;
  color: var(--color);
}

.zLVISyjptq5AheMPzaIQ {
  text-decoration: none;
  color: var(--color);

}

.IkpafeO8ouJGiovENSlt {
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: -35px; */
  margin-top: 0px;
  margin-bottom: 15px;
    /* width: 200px; */
}

.YT6HPQGRv1gXlWOVRp0Y {
  width: 300px;
  height: 100%;
  border: 0.2px solid gray;
}




.MEmz8GTbG9UlPOGtkuV3 {
  display: none;
}

.zLVISyjptq5AheMPzaIQ {
  text-decoration: none;
  color: var(--color);
}



.xP_j46QZNcpY717B_Q56 {
    display: flex;
    /* flex-direction: column; */
    position: fixed;
    /* left: 34rem; */
    /* left: 10px; */
    right: 0px;
    top: 80px;
    /* border: 3px solid red; */
    height: 600px;
    /* max-height: calc(100vh - 70px); */
    width: 175px;
    overflow: hidden;
}





._lTOhEfcoXIYVr_gleSS {
  display: none;
}

.YygaurFw1gs1eNVJ3YZb {
  display: none;
}

.s5yCSMyW9KyT0sxXUaEg {
  /* text-decoration: none;
  color: var(--color); */

  height: 65px;
  /* display: none; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: -35px; */
  margin-top: 0px;
  margin-bottom: 15px;
  text-align: left;
}

.tYaB18IYPPopLujZ5jag {
  text-align: left;
  display: block;
}

.fG6t5j648xckmLbI0CAv {
  height: 90px;
  /* display: none; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: -35px; */
  margin-top: 0px;
  /* margin-bottom: 15px; */
  text-align: left;
}

.Y3Vifg_ufbKcm1HKwyMT {
  height: 130px;
  /* display: none; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: -35px; */
  margin-top: 0px;
  /* margin-bottom: 15px; */
  text-align: left;
}


@media (min-width: 768px) {
  .MEmz8GTbG9UlPOGtkuV3 {
    display: block;
    position: fixed;
    /* left: 34rem; */
    right: 5px;
    top: 75px;
    border: 0.2px solid gray;
    height: 300px;
    width: 300px;
  }


  .IkpafeO8ouJGiovENSlt {
    display: none;
  }

  .YT6HPQGRv1gXlWOVRp0Y {
    display: none;
  }



  

  ._lTOhEfcoXIYVr_gleSS {
    display: flex;
    flex-direction: column;
    position: fixed;
    /* left: 34rem; */
    right: 0px;
    top: 65px;
    /* border: 3px solid red; */
    height: 700px;
    max-height: calc(100vh - 70px);
    width: 330px;
    overflow-y: auto;
  }

  .YygaurFw1gs1eNVJ3YZb {
    display: block;
    width: 305px;
    /* border: 3px solid green; */
  }

  .s5yCSMyW9KyT0sxXUaEg {
    display: none;
  }

}






/* from adnet-frontend keep sync original*/

.bszFnzxVI1AA1acGZrMF {
  width: 300px; 
  height: 65px;
  border: 0.5px solid gray; 
  display: flex; 
  justify-content: space-between;
  margin-bottom: 1rem;
}

.kcoVj6xHfFb049Ck4wRQ {
  width: 235px;
  height: 100%; 
  overflow:hidden; 
  /* padding:  */
}

.c4Avvqf1fG40hPICYKwD {
  display:flex; 
  flex-direction:column; 
  justify-content: space-between; 
  padding:5px 0 0 10px;
}

.a1kchT3fEi6SYRQ4aGev {
  font-size: 16px; 
  font-weight:bold;
  text-align:center;
}

.zcBkzcLhaO5JCzEBpJaH {
  font-size: 12px; 
  font-weight: bold;
  padding-top: 2px;
}

._xNKhIjvkVgi9nVBQlRk {
  width: 65px;
  height:65px;
  object-fit: cover;
}

.QinkFvq__gDDze7OUeiO {
  width: 300px; 
  margin-bottom: 1rem;
}

.o2QRtH13uSD2ZplDbgVZ {
  width: 300px;
  height: 300px;
  /* border: 0.5px solid gray; */
  object-fit: cover;
}

.uc6XlzT9DqodeMsHjGuX {
  width: 300px;
  height: 60px;
  display: flex;
  flex-direction: column;
  /* border: 0.5px solid rgb(231, 231, 231); */
  border: 0.5px solid gray;
  border-radius: 6px;
  padding: 2px 10px 2px 10px;
  overflow: hidden;
  /* background-color: rgb(238, 238, 238); */
  /* justify-content: space-between; */
}

.LTvaGIjMqwI9RaqJGxZg {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.mc1CCVqOBQplL7LqHqac {
  font-size: 13px;
  font-weight: bold;
  padding-top: 4px;
}

.p0olDutzH_V17Hts1wez {
  width: 100%;
  max-width: 40rem; 
  height: 150px; 
  border: 0.5px solid gray;
  border-radius: 6px;
  overflow: hidden;
  /* display: flex; */
}

.TXfal6BeW_ij1lmuwN0Q {
  display: flex;
}

.mtMZwM6Ts47ThBQ3hvYA {
  width: 150px;
  height: 150px;
  /* border: 0.5px solid gray; */
  object-fit: cover;
}

.Yyo_9TI9xpNa2AOLih90 {
  flex-grow: 2;
}

.ZbkhLw5dIZxy68wdyQrQ {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0 10px 0;
}

.Ih57QDpwk6bK2HdEeIja {
  font-size: 16px;
  padding: 0 5px;
}

@media (min-width: 480px) {
  .ZbkhLw5dIZxy68wdyQrQ {
    font-size: 26px;
    font-weight: bold;
    text-align: center;
    padding: 20px 0 10px 0;
  }
  
  .Ih57QDpwk6bK2HdEeIja {
    font-size: 22px;
    padding: 0 20px;
  }
}`, "",{"version":3,"sources":["webpack://./pages/StellarSpaceNews/components/AdElements/AdItems/AdItems.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;;AAErB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;IACjB,kBAAkB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,wBAAwB;AAC1B;;;;;AAKA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;;;AAIA;IACI,aAAa;IACb,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;AACpB;;;;;;AAMA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;wBACsB;;EAEtB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;;AAGA;EACE;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,wBAAwB;IACxB,aAAa;IACb,YAAY;EACd;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;;;;;EAMA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;AAEF;;;;;;;AAOA,0CAA0C;;AAE1C;EACE,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":[".bodyContainer {\n  /* margin-top: 2rem; */\n}\n\n.adLink {\n  text-decoration: none;\n  color: var(--color);\n}\n\n.groupTalkRightElementLink {\n  text-decoration: none;\n  color: var(--color);\n\n}\n\n.groupTalkTopBarElementContainer {\n  height: 65px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* margin-top: -35px; */\n  margin-top: 0px;\n  margin-bottom: 15px;\n    /* width: 200px; */\n}\n\n.groupTalkTopBarElement {\n  width: 300px;\n  height: 100%;\n  border: 0.2px solid gray;\n}\n\n\n\n\n.groupTalkRightElements {\n  display: none;\n}\n\n.groupTalkRightElementLink {\n  text-decoration: none;\n  color: var(--color);\n}\n\n\n\n.right150x500Container {\n    display: flex;\n    /* flex-direction: column; */\n    position: fixed;\n    /* left: 34rem; */\n    /* left: 10px; */\n    right: 0px;\n    top: 80px;\n    /* border: 3px solid red; */\n    height: 600px;\n    /* max-height: calc(100vh - 70px); */\n    width: 175px;\n    overflow: hidden;\n}\n\n\n\n\n\n.rightAdsContainer {\n  display: none;\n}\n\n.rightAdsItem {\n  display: none;\n}\n\n.topAdElementContainer {\n  /* text-decoration: none;\n  color: var(--color); */\n\n  height: 65px;\n  /* display: none; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* margin-top: -35px; */\n  margin-top: 0px;\n  margin-bottom: 15px;\n  text-align: left;\n}\n\n.inPostsAdElementContainer {\n  text-align: left;\n  display: block;\n}\n\n.top450x90AdElementContainer {\n  height: 90px;\n  /* display: none; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* margin-top: -35px; */\n  margin-top: 0px;\n  /* margin-bottom: 15px; */\n  text-align: left;\n}\n\n.top600x130AdElementContainer {\n  height: 130px;\n  /* display: none; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* margin-top: -35px; */\n  margin-top: 0px;\n  /* margin-bottom: 15px; */\n  text-align: left;\n}\n\n\n@media (min-width: 768px) {\n  .groupTalkRightElements {\n    display: block;\n    position: fixed;\n    /* left: 34rem; */\n    right: 5px;\n    top: 75px;\n    border: 0.2px solid gray;\n    height: 300px;\n    width: 300px;\n  }\n\n\n  .groupTalkTopBarElementContainer {\n    display: none;\n  }\n\n  .groupTalkTopBarElement {\n    display: none;\n  }\n\n\n\n  \n\n  .rightAdsContainer {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    /* left: 34rem; */\n    right: 0px;\n    top: 65px;\n    /* border: 3px solid red; */\n    height: 700px;\n    max-height: calc(100vh - 70px);\n    width: 330px;\n    overflow-y: auto;\n  }\n\n  .rightAdsItem {\n    display: block;\n    width: 305px;\n    /* border: 3px solid green; */\n  }\n\n  .topAdElementContainer {\n    display: none;\n  }\n\n}\n\n\n\n\n\n\n/* from adnet-frontend keep sync original*/\n\n.body300x65Container {\n  width: 300px; \n  height: 65px;\n  border: 0.5px solid gray; \n  display: flex; \n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.body300x65Text {\n  width: 235px;\n  height: 100%; \n  overflow:hidden; \n  /* padding:  */\n}\n\n.body300x65TextContents {\n  display:flex; \n  flex-direction:column; \n  justify-content: space-between; \n  padding:5px 0 0 10px;\n}\n\n.body300x65TextTitle {\n  font-size: 16px; \n  font-weight:bold;\n  text-align:center;\n}\n\n.body300x65TextDescription {\n  font-size: 12px; \n  font-weight: bold;\n  padding-top: 2px;\n}\n\n.body300x65Image {\n  width: 65px;\n  height:65px;\n  object-fit: cover;\n}\n\n.body300x300Container {\n  width: 300px; \n  margin-bottom: 1rem;\n}\n\n.body300x300Image {\n  width: 300px;\n  height: 300px;\n  /* border: 0.5px solid gray; */\n  object-fit: cover;\n}\n\n.body300x300TextContainer {\n  width: 300px;\n  height: 60px;\n  display: flex;\n  flex-direction: column;\n  /* border: 0.5px solid rgb(231, 231, 231); */\n  border: 0.5px solid gray;\n  border-radius: 6px;\n  padding: 2px 10px 2px 10px;\n  overflow: hidden;\n  /* background-color: rgb(238, 238, 238); */\n  /* justify-content: space-between; */\n}\n\n.body300x300TextTitle {\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.body300x300TextDescription {\n  font-size: 13px;\n  font-weight: bold;\n  padding-top: 4px;\n}\n\n.bodyInPostContainer {\n  width: 100%;\n  max-width: 40rem; \n  height: 150px; \n  border: 0.5px solid gray;\n  border-radius: 6px;\n  overflow: hidden;\n  /* display: flex; */\n}\n\n.bodyInPostContents {\n  display: flex;\n}\n\n.bodyInPostImageContainer {\n  width: 150px;\n  height: 150px;\n  /* border: 0.5px solid gray; */\n  object-fit: cover;\n}\n\n.bodyInPostTextContainer {\n  flex-grow: 2;\n}\n\n.bodyInPostTextTitle {\n  font-size: 16px;\n  font-weight: bold;\n  text-align: center;\n  padding: 20px 0 10px 0;\n}\n\n.bodyInPostTextDescription {\n  font-size: 16px;\n  padding: 0 5px;\n}\n\n@media (min-width: 480px) {\n  .bodyInPostTextTitle {\n    font-size: 26px;\n    font-weight: bold;\n    text-align: center;\n    padding: 20px 0 10px 0;\n  }\n  \n  .bodyInPostTextDescription {\n    font-size: 22px;\n    padding: 0 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyContainer": `J1PHBbR3GyfoEvqufIPe`,
	"adLink": `E76NuDfGxJ8wj35W3a03`,
	"groupTalkRightElementLink": `zLVISyjptq5AheMPzaIQ`,
	"groupTalkTopBarElementContainer": `IkpafeO8ouJGiovENSlt`,
	"groupTalkTopBarElement": `YT6HPQGRv1gXlWOVRp0Y`,
	"groupTalkRightElements": `MEmz8GTbG9UlPOGtkuV3`,
	"right150x500Container": `xP_j46QZNcpY717B_Q56`,
	"rightAdsContainer": `_lTOhEfcoXIYVr_gleSS`,
	"rightAdsItem": `YygaurFw1gs1eNVJ3YZb`,
	"topAdElementContainer": `s5yCSMyW9KyT0sxXUaEg`,
	"inPostsAdElementContainer": `tYaB18IYPPopLujZ5jag`,
	"top450x90AdElementContainer": `fG6t5j648xckmLbI0CAv`,
	"top600x130AdElementContainer": `Y3Vifg_ufbKcm1HKwyMT`,
	"body300x65Container": `bszFnzxVI1AA1acGZrMF`,
	"body300x65Text": `kcoVj6xHfFb049Ck4wRQ`,
	"body300x65TextContents": `c4Avvqf1fG40hPICYKwD`,
	"body300x65TextTitle": `a1kchT3fEi6SYRQ4aGev`,
	"body300x65TextDescription": `zcBkzcLhaO5JCzEBpJaH`,
	"body300x65Image": `_xNKhIjvkVgi9nVBQlRk`,
	"body300x300Container": `QinkFvq__gDDze7OUeiO`,
	"body300x300Image": `o2QRtH13uSD2ZplDbgVZ`,
	"body300x300TextContainer": `uc6XlzT9DqodeMsHjGuX`,
	"body300x300TextTitle": `LTvaGIjMqwI9RaqJGxZg`,
	"body300x300TextDescription": `mc1CCVqOBQplL7LqHqac`,
	"bodyInPostContainer": `p0olDutzH_V17Hts1wez`,
	"bodyInPostContents": `TXfal6BeW_ij1lmuwN0Q`,
	"bodyInPostImageContainer": `mtMZwM6Ts47ThBQ3hvYA`,
	"bodyInPostTextContainer": `Yyo_9TI9xpNa2AOLih90`,
	"bodyInPostTextTitle": `ZbkhLw5dIZxy68wdyQrQ`,
	"bodyInPostTextDescription": `Ih57QDpwk6bK2HdEeIja`
};
export default ___CSS_LOADER_EXPORT___;
